import { createSelector, select } from '@ngrx/store';
import { MedicationScheme } from 'vidis-common/medication';
import { AppState } from '../reducers/app.state';
import { map, pipe, filter } from 'rxjs';

export const selectMedicationStateMedicationSchemes = (state: AppState) => state.medicationData.medicationSchemes
    ? state.medicationData.medicationSchemes[0]
    : null;
export const selectMedicationStateMedicationErrors = (state: AppState) => state.medicationData.medicationErrors;

export const selectMedicationSchemeMedications = createSelector(
    selectMedicationStateMedicationSchemes,
    (medicationScheme: MedicationScheme) => medicationScheme?.medications
);

export const selectIsMedicationSchemeLoading = (state: AppState) => state.medicationData.medicationSchemeLoading;
export const selectMedicationSchemeIsLoaded = (state: AppState) => state.medicationData.isLoaded;

export const selectMedicationSchemeWithError = pipe(
  select((state: AppState) => state.medicationData),
  filter(({ medicationSchemeLoading }) => !medicationSchemeLoading),
  map(({ medicationSchemes, medicationErrors }) => ({
    scheme: medicationSchemes?.[0],
    error: medicationErrors
  }))
);
